import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, Link } from 'react-router-dom';
import Orders from './Orders';
import Reviews from './Reviews';
import Posts from './Posts';
import Gallary from './Gallary';
import Following from './Following';
import Strain from './Strain';
import Edit from './Edit';
import {IMAGE_URL} from '../../Constants/constants';
import About from './About';
import Messages from './Messages';


const Profile = (props) => {
	const user = useSelector(state => state.user)

	console.log('profile user', user)
	return (
		<React.Fragment>
			<div className="site_wrap">
				<div id="bg_map_container_container" className="has_filter" style={{ display: 'none' }}>
					<div id="bg_map_container">
						<div id="bg_map" />
					</div>
				</div>
				<div className="body_wrap">
					<div className="shadow">
						<div className="content_wrap">
							<div className="main user_profile" data-id={837998}>
								<div id="sub_content" className="user_content2">
									<div className="user_header">
										<div className="wrapper">
											<div className="user_thumb">
												<Link to="/profile">
													{user.image ?
														<img src={IMAGE_URL+user.image} alt="profile-bedge" /> :
														<img src="/images/smoke1.png" alt="profile-bedge" />}
												</Link>
											</div>
											<div className="name">
												<h1>
													<Link to="/profile">{user.username}</Link>
												</h1>
											</div>

											<span className="profile_cta"><Link to="/profile/edit" className="edit" style={{textDecoration: 'none'}}>
												<span className="icon-pencil" /> Edit Profile</Link>
											</span>
											<div className="profile_stats">
												<ul>
													<li>
														<Link to="/profile/gallary">
															<span className="count">0</span>
															<span className="label">Photos</span>
														</Link>
													</li>
													<li>
														<Link to="/profile/reviews">
															<span className="count">0</span>
															<span className="label">Reviews</span>
														</Link>
													</li>
													<li>
														<Link to="/profile/following">
															<span className="count">0</span>
															<span className="label">Following</span>
														</Link>
													</li><li>
														<a href="/checkins_strains">
															<span className="count">0</span>
															<span className="label">Checkins</span>
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="profile_left_nav">
										<div className="wrapper">
											<ul>
												<li className="user_hide dash"><Link to="/profile" className="dashboard active" data-nav="home"><span className="icon-home icon" /><span className="label" /></Link></li>
												<li>
													<Link to="/profile/pre-orders" className="orders" data-nav="pre-orders">
														<span className="icon-shopping2 icon" /><span className="label">Pre-Orders</span>
													</Link>
												</li>
												<li className="user_hide">
													<a href="/profile/checkins_strains" className="friends_link" data-nav="checkins">
												<span className="icon-location-2 icon" /><span className="label">Strain Check-ins</span></a>
												</li>
												<li>
													<a href="/profile/wishlist" className="wishlist_link" data-nav="wishlist">
														<span className="icon-users icon" />
														<span className="number">0</span>
														<span className="label">Wishlist</span>
													</a>
												</li>
												<li>
													<a href="/profile/badges" className="badges_link" data-nav="badges">
													<span className="icon-users icon" /><span className="number">0</span>
													<span className="label">Badges</span></a>
												</li>
												<li>
													<a href="/profile/friends" className="friends_link" data-nav="friends">
													<span className="icon-users icon" /><span className="number">0</span>
													<span className="label">Friends</span></a>
												</li>
												<li className="user_hide">
													<Link to="/profile/following" className="following2" data-nav="following">
														<span className="icon-city5 icon" /><span className="number">0</span>
														<span className="label">Following</span>
													</Link>
												</li>
												<li className="user_hide">
													<Link to="/profile/gallery" className="gallery" data-nav="gallery">
														<span className="icon-camera-2 icon" /><span className="number">0</span>
														<span className="label">Pictures</span>
													</Link>
												</li>
												<li className="user_hide">
													<Link to="/profile/reviews" className="reviews" data-nav="reviews">
														<span className="icon-bubbles icon" />
														<span className="number">0</span>
														<span className="label">Reviews</span>
													</Link>
													</li>
												<li>
													<a href="/profile/about" className="about" data-nav="about"><span className="icon-bubble-quote icon" />
													<span className="label">About</span></a>
												</li>
												<li>
													<a href="/profile/inbox" className="contact"><span className="icon-envelop icon" />
													<span className="number" /><span className="label">Inbox</span></a>
												</li>
											</ul>
											<div className="user_expand" data-toggle="fullsize" data-target=".profile_left_nav">(more)</div>
										</div>
									</div>
									{/*- Begin User body-*/}
									<div className="wrapper">
										<div className="user_lists c_3">
											<div className="left_user_box strains">
												<span className="heading">
													Strains
												</span>
												<ul className="strain_stats">
													<li className="checkins">
														<a href="/profile/checkins_strains">
															<span className="number">0</span>
															<span className="label">Check-Ins</span>
														</a>
													</li>
													<li className="wishlist wishlist_count">
														<a href="/profile/wishlist">
															<span className="number">0</span>
															<span className="label">Wishlist</span>
														</a>
													</li>
													<li className="badges">
														<a href="/profile/badges">
															<span className="number">0</span>
															<span className="label">Badges</span>
														</a>
													</li>
												</ul>
											</div>
											<div className="left_user_box preorders">
												<span className="heading">
													<Link to="/profile/pre-orders">Pre-Orders <span className="more2">See All</span></Link>
												</span>
												<p>Where's JPlug makes it easy to pre-order your purchases thorugh participating businesses.</p>
												<ul className="tab_nav">
													<li className="active"><Link to="/profile/pre-orders">Current Orders</Link></li>
													<li><Link to="/profile/pre-orders/inactive">Previous Orders</Link></li>
												</ul>
												<p className="no_orders">You have no current orders! <Link to="/">Find a business!</Link></p>
											</div>
											<div className="left_user_box followers">
												<span className="heading">
													<a href="#">Followers <span className="more2">See All</span></a>
												</span>
												<ul>
													<li>
														<a href="/users/JPlugo"><img src="/images/smoke1.png" />
														</a>
													</li>
												</ul>
											</div>
										</div>

										<Routes>
											<Route path="gallary" element={<Gallary />} />
											<Route path="about" element={<About />} />
											<Route path="edit" element={<Edit user={user} />} />
											<Route path="inbox" element={<Messages user={user} />} />
											<Route path="following" element={<Following />} />
											<Route path="pre-orders/*" element={<Orders />} />
											<Route path="reviews/*" element={<Reviews />} />
											<Route path="/" element={<Posts />} />
											<Route path="checkins_strains" element={<Strain />} />
										</Routes>
									</div>
									<div className="clear" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Profile;